import React, { FC, ReactElement } from "react";
import Link from "next/link";
import getConfig from "next/config";
import { observer } from "mobx-react";
import Container from "ui/Container/Container";
import buttonStyles from "ui/Button/Button.module.scss";
import RegionLabel from "common/RegionLabel/RegionLabel";
import AddressMini from "assets/icons/address-mini.svg";
import { useStore } from "store";
import { useUrl } from "helpers/hooks";
import { cn } from "helpers/style";
import { LinkPropsOptions, withTrailSlash } from "helpers/url";
import { CONTACT_PHONE_NUMBER } from "constants/variables";
import { ROUTE_INSTRUCTION } from "constants/routes";
import styles from "./Info.module.scss";

const { publicRuntimeConfig } = getConfig();

type MenuItems = Array<{
  path: string;
  text: string;
  origin: LinkPropsOptions["withOrigin"];
  region?: LinkPropsOptions["withRegion"];
}>;

const MENU: MenuItems = [
  {
    path: withTrailSlash(ROUTE_INSTRUCTION),
    text: "Как сделать заказ",
    origin: false,
  },
  { path: "/dostavka/", text: "Доставка и оплата", region: true, origin: true },
  {
    path: publicRuntimeConfig.BLOG_URL,
    text: "Читать про здоровье",
    origin: true,
  },
];

type Props = {
  mobileIsOpen?: boolean;
  contactPhone?: string;
};

const Info: FC<Props> = ({
  mobileIsOpen,
  contactPhone,
}: Props): ReactElement => {
  const { user } = useStore();
  const { getLinkProps } = useUrl();

  const handleAuth = e => user.withAuth({ event: e });

  return (
    <div
      className={cn([
        styles.info,
        mobileIsOpen && styles.mobileOpen,
        user.isEmployeeMode && styles.infoEmployee,
      ])}
    >
      <Container>
        <div className={styles.grid}>
          <div className={styles.left}>
            <div
              className={cn([
                styles.address,
                mobileIsOpen && styles.mobileOpen,
              ])}
            >
              <RegionLabel icon={<AddressMini />} />
            </div>

            <div className={styles.menu}>
              {MENU.map(item => {
                return (
                  <Link
                    key={item.text}
                    {...getLinkProps(item.path, item.path, {
                      withRegion: !!item.region,
                      withOrigin: item.origin,
                    })}
                    className={styles.menuLink}
                    passHref
                  >
                    {item.text}
                  </Link>
                );
              })}
            </div>
          </div>
          <div>
            <div className={styles.phones}>
              <span>Служба поддержки</span>
              <a href={`tel:${contactPhone ?? CONTACT_PHONE_NUMBER}`}>
                {contactPhone ?? CONTACT_PHONE_NUMBER}
              </a>
              <span>Круглосуточно</span>
            </div>

            <Link
              href={
                user.isAuth
                  ? getLinkProps(
                      `/personal/${user.profile?.id}/history/`,
                      undefined,
                      { withRegion: false, withOrigin: true }
                    ).as
                  : "/"
              }
              onClick={handleAuth}
              passHref
            >
              <button
                className={cn([
                  buttonStyles.button,
                  styles.orderButton,
                  mobileIsOpen && styles.mobileOpen,
                ])}
              >
                Что с моим заказом?
              </button>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default observer(Info);
